export const appLevelPaths = ['/organisations', '/create', '/admin/dashboard']
